import { Link } from 'react-router-dom';
import { makeMsisdnBeautiful } from '../../../Utils';
import React from 'react';
import TEXTS from '../../../locale/texts';

export const allContactsColumns = (lang) => [
  {
    title: TEXTS.contactPhoneLabel[lang],
    dataIndex: 'msisdn',
    width: 200,
    render: (text, record) => <Link
        className="ant-btn-link"
        to={`/phonebook/contacts/${record.msisdn}_${record.id}`}>
      {(typeof text === 'number' || typeof text === 'string')
          ? makeMsisdnBeautiful(text)
          : '—'}
    </Link>,
  },
  {
    title: TEXTS.thFIO[lang],
    width: 300,
    render: (text, {firstname, lastname, middlename}) => {
      const _firstname = firstname && typeof firstname === 'string'
          ? firstname
          : '—';
      const _lastname = lastname && typeof lastname === 'string'
          ? ' ' + lastname
          : '';
      const _middlename = middlename && typeof middlename === 'string'
          ? ' ' + middlename
          : '';
      return `${_firstname}${_lastname}${_middlename}`;
    }
  },
  {
    title: TEXTS.thPhoneGroups[lang],
    dataIndex: 'groups',
    width: 300,
    render: (text) => typeof text === 'string' ? text : '—'
  },
  {
    title: TEXTS.thGender[lang],
    dataIndex: 'gender',
    width: 150,
    render: (text) => typeof text === 'string'
    && text.match(/^(M|F)$/) ? (text === 'M' ? 'Муж.' : 'Жен.') : '—'
  },
  {
    title: TEXTS.birthDate[lang],
    dataIndex: 'birthDate',
    width: 200,
    render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
  }
];
